module.exports = __webpack_public_path__ + "static/media/who-3.18461d88.jpg";